<p-fluid class="flex flex-col md:flex-row gap-20" style="padding-left: 2%; padding-right: 2%;">
    <div class="md:w-1/4">
        <div class="card flex flex-col gap-4 items-center">
            <img src="./assets/img/perfildemo.jpg" alt="Perfil" class="rounded-full" />
            <!-- <span class="font-semibold">{{ currentUserData?.firstName }} {{ currentUserData?.lastName }}</span> -->
        </div>

    </div>
    <div class="md:w-3/4">
        <div class="card flex flex-col gap-4">
            <div class="font-semibold text-center text-xl">Datos de Usuario</div>
            <form [formGroup]="formUserUpd">
                <div class="grid grid-cols-12 gap-4">

                    <div class="col-span-6">
                        <p-floatlabel variant="on">
                            <label for="userNameUpd">Nombre</label>
                            <input pInputText formControlName="userNameUpd" id="userNameUpd" type="text" />
                        </p-floatlabel>
                    </div>
                    <div class="col-span-6">
                        <p-floatlabel variant="on">
                            <label for="lastNameUpd">Apellido</label>
                            <input pInputText formControlName="lastNameUpd" id="lastNameUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-12">
                        <p-floatlabel variant="on">
                            <label for="addressUserUpd">Dirección</label>
                            <input pInputText formControlName="addressUserUpd" id="addressUserUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="ciUserUpd">Cédula</label>
                            <input pInputText formControlName="ciUserUpd" id="ciUserUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="telUserUpd">Teléfono</label>
                            <input pInputText formControlName="telUserUpd" id="telUserUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="emailUpd">Email</label>
                            <input pInputText formControlName="emailUpd" id="emailUpd" type="email" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-4">
                        <p-floatlabel variant="on">
                            <label for="userUpd">Usuario</label>
                            <input pInputText formControlName="userUpd" id="userUpd" type="text" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="passwordUpd">Contraseña</label>
                            <input pInputText formControlName="passwordUpd" id="passwordUpd" type="password" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="passwordReUpd">Repita Contraseña</label>
                            <input pInputText formControlName="passwordReUpd" id="passwordReUpd" type="password" />
                        </p-floatlabel>
                    </div>
                    <div class="col-span-3">
                        <p-floatlabel variant="on">
                            <label for="passwordReUpd">PIN</label>
                            <input pInputText formControlName="passwordReUpd" id="passwordReUpd" type="password" />
                        </p-floatlabel>
                    </div>

                    <div class="col-span-12">
                        <div class="flex grid-cols-12 gap-4 justify-center">
                            @if(editUserData){
                            <p-button severity="danger" label="Cancelar" text icon="pi pi-times"
                                (click)="cancelEditUser()" />
                            <p-button severity="success" label="Guardar" text icon="pi pi-check"
                                (click)="savePassword()" />
                            }
                            @if(!editUserData){
                            <p-button severity="secondary" label="Editar Contraseña" text icon="pi pi-user-edit"
                                (click)="editUser()" />
                            }
                        </div>
                    </div>
                </div>
            </form>


        </div>
    </div>
</p-fluid>